import BatIcon from "@/components/logos/BatIcon";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/maintenance/")({
  head: () => ({
    meta: [{ title: "Reactor | Maintenance" }],
  }),
  component: MaintenancePage,
});

function MaintenancePage() {
  return (
    <div className="relative flex min-h-screen w-screen items-center justify-center bg-[#0B0B11]">
      <img
        alt="bg-visual"
        src="/images/login_bg.webp"
        className="absolute inset-0 z-0 hidden h-full w-full object-left md:block"
      />
      <div className="z-10 mx-3 flex w-full max-w-[530px] flex-col items-center rounded-[25px] bg-card px-5 pb-[52px] pt-[44px]">
        <div className="mb-3 flex h-[60px] w-[60px] items-center justify-center rounded-full bg-dark-green p-3 md:h-[72px] md:w-[72px]">
          <BatIcon />
        </div>
        <p className="mb-4 text-3xl">Maintenance</p>
        <p className="text-center text-base text-gray-p">
          We&apos;re currently performing maintenance on the platform. We will
          be operational soon
        </p>
      </div>
    </div>
  );
}
